<script setup lang="ts">
import { useI18n } from "vue-i18n";

import { config } from "@/config";

import LeErrorResult from "./LeErrorResults.vue";

const { t } = useI18n();
const { phone } = config.ordbogen;
</script>

<template>
  <LeErrorResult>
    <template #header>
      {{ t("le-error-results.license-not-available.headline") }}
    </template>
    <template #paragraph1>
      {{ t("le-error-results.license-not-available.paragraph1") }}
    </template>
    <template #section>
      {{ t("le-error-results.license-not-available.section-header") }}
    </template>
    <template #paragraph2>
      <i18n-t keypath="le-error-results.license-not-available.paragraph2">
        <template #phone>
          <a :href="`tel:${phone.number}`" class="le-license-not-available-error__link">{{ phone.display }}</a>
        </template>
      </i18n-t>
    </template>
  </LeErrorResult>
</template>

<style lang="less" scoped>
@import "@dsk/styles/all";

.le-license-not-available-error__link {
  color: @colors[@primary][700];

  &:hover {
    text-decoration: underline;
  }
}
</style>
